<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).ready(function() {    
    setInterval(function () {
      $(".product-item[data-product-id='9742455374143']").parent(".product").remove();
      $('.previewCartItem-remove[data-cart-remove-id="49849331745087"]').addClass("custom_remove_cart_item");      
      if($("body.template-cart").length != 0){
        if($('.cart-remove[data-cart-remove-id="49849331745087"]').length == 0){
          const button = document.querySelector('giftnote-core');
          const shadowRoot = button.shadowRoot;
          const elementToClick = shadowRoot.getElementById('remove-button');
          shadowRoot.getElementById("alerts").style.display = 'none';
          elementToClick.click();
        }
      }
    }, 10);
    if($('giftnote-button').length != 0){
      function gift_box() {
        const giftnote_button = $('giftnote-button');
        const giftnote_shadowRoot = giftnote_button[0].shadowRoot;
        const gift_text = $(giftnote_shadowRoot).find('#button span#add.hidden').length;
        const gift_text_add = $(giftnote_button).data("add");
        const gift_text_edit = $(giftnote_button).data("edit");
        $(".giftnote-custom-button").remove();        
        if(gift_text){
          $("giftnote-button").parent(".shopify-app-block").append("<div class='giftnote-custom-button checked'>" + gift_text_edit + "</div>");
          fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => response.json())
            .then((data) => {
              if(data.items.length != 0){
                var Free_Product_id = 49849331745087;
                var freeFound = true;
                for(var i = 0; i< data.items.length; i++){
                  if(data.items[i].variant_id == Free_Product_id){
                    var freeFound = false;
                  }
                }
                if(freeFound == true){
                  $.ajax({
                     type: 'POST',
                     url: '/cart/add.js',
                     dataType: 'json',
                     data: {
                       id: Free_Product_id,
                       quantity: 1
                     },
                     success: function(response) {
                       console.log(response);
                       if($('.previewCartItem-remove[data-cart-remove-id="49704128151871"]').length == 1){
                         location.reload();
                       }
                     },
                     error: function(xhr, status, error) {
                       console.error('Error adding product to cart:', xhr.responseText);
                     }
                  });
                }
              }
            });        
        }else{
          $("giftnote-button").parent(".shopify-app-block").append("<div class='giftnote-custom-button'>" + gift_text_add + "</div>");
          fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => response.json())
            .then((data) => {
              if(data.items.length != 0){
                var Free_Product_id = 49849331745087;
                var freeFound = false;
                for(var i = 0; i< data.items.length; i++){
                  if(data.items[i].variant_id == Free_Product_id){
                    var freeFound = true;
                  }
                }
                if(freeFound == true){
                  $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    dataType: 'json',
                    data: {
                      id: Free_Product_id,
                      quantity: 0
                    },
                    success: function(response) {
                      console.log(response);                      
                      location.reload();
                    },
                    error: function(xhr, status, error) {
                      console.error('Error adding product to cart:', xhr.responseText);
                    }
                  });
                }
              }
           });
        }
        $(".giftnote-custom-button:not(.checked)").click(function(){
          const button = document.querySelector('giftnote-button');
          const shadowRoot = button.shadowRoot;
          const elementToClick = shadowRoot.getElementById('button');
          elementToClick.click();
        });
        $(".giftnote-custom-button.checked").click(function(){
          const button = document.querySelector('giftnote-core');
          const shadowRoot = button.shadowRoot;
          const elementToClick = shadowRoot.getElementById('remove-button');
          elementToClick.click();
        });        

        $(".custom_remove_cart_item").click(function(e){
          e.preventDefault();
          $(this).parents("li.previewCartItem").remove();
          const button = document.querySelector('giftnote-core');
          const shadowRoot = button.shadowRoot;
          const elementToClick = shadowRoot.getElementById('remove-button');
          elementToClick.click();
          var Free_Product_id = 49849331745087;
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              id: Free_Product_id,
              quantity: 0
            },
            success: function(response) {
              console.log(response);
            },
            error: function(xhr, status, error) {
              console.error('Error adding product to cart:', xhr.responseText);
            }
          });
        });        
      }    
                  
      setInterval(function () {
        gift_box();
      }, 3000); 
    }
});